<template>
  <div class="surveillance-convention-modal">
    <modal v-model="conventionModal"
           class="convention-modal-container"
           size="lg"
           v-if="mounted"
           @hide="conventionModalEnded"
           :footer="false">
      <template slot="header">
        <div class="text-center">
          SPIADI{{surveillance.year}} - CHARTE D'ENGAGEMENT
        </div>
      </template>
      <div v-if="conventionModal"
           class="convention-modal">
        <div class="text-center">
          <div>
            <h3>
              {{ surveillance.establishment.name }}
              <p>
                <small v-if="conventionReceived">
                  Dernière modification le {{ conventionReceptionDate }}
                </small>
              </p>
            </h3>
            <h4>
              <span :class="status.class" class="label">
                {{ surveillance.year }} : {{ status.title }}
              </span>
            </h4>
          </div>
        </div>
        <div v-if="conventionRefused">
          <hr />
          <h4 class="text-center">Motif du refus</h4>
          <alert type="info">
            <p>
              <strong>
                {{ surveillance.cvt.error }}
              </strong>
            </p>
          </alert>
        </div>
        <div v-if="!actions.empty">
          <hr />
          <div v-if="convention.uploading">
            <alert type="info">
              <strong>Envoi de la charte en cours...</strong>
              <p>
                Veuillez patienter, cela peut prendre quelques minutes.
              </p>
              <progress-bar v-model="convention.uploadPercentage"
                            striped
                            active />
            </alert>
          </div>
          <div class="action-bar">
            <div class="action-item"
                 v-show="actions.dl">
              <btn type="default"
                   @click="downloadConvention()"
                   :disabled="conventionBusy" block>
                Télécharger la charte
              </btn>
              <save-blob :target="convention.download"></save-blob>
            </div>
            <div class="action-item"
                 v-show="actions.up">
              <btn type="warning"
                   @click="prepareUpload(null)"
                   :disabled="conventionBusy" block>
                Envoyer la charte
              </btn>
              <input ref="conventionModalFileInput"
                     accept="application/pdf"
                     v-show="false"
                     type="file"
                     @change="uploadConvention($event)"
                     single>
            </div>
            <div class="action-item"
                 v-show="actions.acc"
                 :disabled="conventionBusy">
              <btn type="success" @click="acceptConvention()" block>
                Accepter tout
              </btn>
            </div>
            <div class="action-item"
                 v-show="actions.ref"
                 :disabled="conventionBusy">
              <btn type="danger" @click="refuseConvention()" block>
                Refuser
              </btn>
            </div>
          </div>
        </div>
        <div class="roles-container">
          <div v-for="r in roles" :key="r.key">
            <hr />
            <h4 class="text-center">
              <span v-html="r.title"></span><br />
              <small v-show="r.subtitle !== ''">
                {{ r.subtitle }}
              </small>
            </h4>
            <div class="row">
              <div class="col-xs-6 col-xs-offset-1">
                <ul>
                  <li><b>Nom : </b>{{r.src.name}}</li>
                  <li><b>Prénom : </b>{{r.src.fn}}</li>
                  <li><b>Adresse e-mail : </b>{{r.src.eml}}</li>
                </ul>
              </div>
              <div class="col-xs-4">
                <p v-show="r.stat.show" class="text-center">
                  <span class="label" :class="r.stat.class">
                    {{ r.stat.text }}
                  </span>
                </p>
                <div class="action-bar">
                  <div v-show="r.dl" class="text-center action-item">
                    <btn type="default" @click="downloadAmendment(r.file)"
                         :disabled="conventionBusy" size="sm">
                      Télécharger
                    </btn>
                  </div>
                  <div v-show="r.send" class="text-center action-item">
                    <btn type="warning" @click="prepareUpload(r.file.role)"
                         :disabled="conventionBusy" size="sm">
                      Envoyer
                    </btn>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <hr>
        </div>
      </div>
      <div class="row" v-if="!showConventionHistory">
        <div class="col-xs-12 text-center">
          <btn @click="refreshHistoryIFN(true)" type="info">
            Afficher l'historique
          </btn>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-xs-12">
          <h4 class="text-center">Historique</h4>
          <table class="table table-responsive">
            <tbody>
              <tr>
                <th role="button" @click="toggleDateSort" unselectable="on">
                  Date
                  <small class="glyphicon"
                         :class="`glyphicon-sort-by-attributes${dateSort ? '-alt' : ''}`">
                  </small>
                </th>
                <th>Utilisateur</th>
                <th>Surveillance</th>
                <th>Document</th>
                <th style="width: 100%;">Signataires</th>
              </tr>
              <tr v-for="r in conventionHistoryDisplay" :key="r.key" :class="r.style">
                <td>{{ r.dateDisplay }}</td>
                <td v-html="r.user"></td>
                <td>
                  <span v-if="r.survStatus" v-html="r.survStatus">
                  </span>
                </td>
                <td>
                  <span v-if="r.cvtStatus != null && r.cvtStatus.length > 0">
                    <div v-for="(u, k) in r.cvtStatus" :key="`user-${k}`">
                      <span v-html="u"></span>
                    </div>
                  </span>
                </td>

                <td>
                  <div v-for="u in r.users" :key="`user-${u.key}`">
                    <span v-html="u.text"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modal>
    <modal v-model="reasonModal"
           v-if="mounted"
           @hide="reasonModalEnded"
           :before-close="checkReason"
           ok-text="Refuser" ok-type="danger"
           title="Refus de la charte d'engagement"
           cancel-text="Annuler" cancel-type="default">
      <template slot="header">
        <div class="text-center">
          REFUS DE LA CHARTE D'ENGAGEMENT
        </div>
      </template>
      <div v-if="reasonModal">
        <h3 class="text-center">
          {{ surveillance.establishment.name }}
        </h3>
        <hr />
        <div v-if="reason.type === 1" class="row">
          <div class="col-xs-6 text-center">
            <c-checkbox type="bactADI" v-model="reason.whole" block
                        @input="reason.amend = !reason.whole">
              Refuser la charte
            </c-checkbox>
          </div>
          <div class="col-xs-6 text-center">
            <c-checkbox type="reaBactADI" v-model="reason.amend" block
                        @input="reason.whole = !reason.amend">
              Refuser par avenants
            </c-checkbox>
          </div>
          <div class="col-xs-12">
            <hr />
          </div>
        </div>
        <div v-for="r in roles" :key="r.key">
          <div class="row" v-if="r.wait">
            <div class="col-xs-5">
              <strong v-html="r.title"></strong>
            </div>
            <div class="col-xs-3">
              <label class="label label-danger" v-if="reason[r.key] === 1">
                Avenant refusé
              </label>
              <label class="label label-success" v-else-if="reason[r.key] === 3">
                Avenant accepté
              </label>
              <label class="label label-warning" v-else-if="r.src.stat === 2">
                Avenant en attente
              </label>
              <label class="label label-info" v-else>
                Avenant inexistant
              </label>
            </div>
            <div class="col-xs-2 text-center">
              <btn type="success" @click="reason[r.key] = 3" size="xs"
                   v-if="r.src.stat === 2">
                Accepter
              </btn>
              <btn type="info" @click="reason[r.key] = 0" size="xs"
                   v-else-if="reason[r.key] > 0">
                Ignorer
              </btn>
            </div>
            <div class="col-xs-2 text-center">
              <btn type="danger" @click="reason[r.key] = 1" size="xs">
                Refuser
              </btn>
            </div>

            <div class="col-xs-12">
              <hr  />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="reason" class="control-label">Motif</label>
          <textarea required
                    id="reason"
                    tabindex="1"
                    class="form-control"
                    rows="7"
                    v-model.trim="reason.text"
                    placeholder="Message..."/>
        </div>
        <alert type="danger" v-if="reason.error !== ''">
          <p class="text-justify">
            {{ reason.error }}
          </p>
        </alert>
      </div>
    </modal>
  </div>
</template>

<script>
import checkbox from '@/sui/components/checkbox'
import convention from '@/components/surveillance/impl/convention'
import saveBlob from '@/sui/components/saveblob'
import date from '@/sui/tools/date'
import assert from '@/sui/tools/assert'

import go from '@/gojs/go'
import moment from 'moment'

export default {
  name: 'surveillance-convention-modal',

  props: {
    surveillance: Object,
    value: Boolean
  },

  data: function () {
    return {
      dateSort: true,
      mounted: false,
      removeModal: false,
      conventionModal: this.value,
      convention: {
        uploading: false,
        busy: false,
        uploadPercentage: 0,
        download: null
      },
      conventionHistoryData: null,
      reasonModal: false,
      reason: {
        text: '',
        error: '',
        reg: 0,
        dir: 0,
        bio: 0,
        type: 0,
        amend: false,
        whole: false
      }
    }
  },

  computed: {
    conventionHistoryList: function () {
      const data = this.conventionHistoryData
      if (data == null) {
        return null
      }

      const styles = [
        'bg-light-expADI',
        'bg-light-chronoBioLine'
      ]
      const originStyles = [
        'primary',
        'reaInfADI',
        'expADI',
        'gray'
      ]
      let lineStyle = 0

      const result = []
      let previousLine = null
      let lastYear = 0

      for (let i = 0; i !== data.length; ++i) {
        const item = data[i]

        let line = previousLine
        const date = moment(item.date)

        if (line == null ||
            date.diff(line.date, 'seconds') > 0 ||
            (line.survStatus != null && item.surv != null) ||
            (line.cvtStatus != null && item.cvt != null)) {
          if (line != null) {
            result.push(line)
            lastYear = line.year

            if (item.surv != null && lastYear !== item.surv.year) {
              lineStyle = (lineStyle + 1) % 2
            }
          }

          assert(item.orig >= 0)
          assert(item.orig < originStyles.length)
          const userStyle = originStyles[item.orig]

          line = {
            date: date,
            dateDisplay: date.format('DD/MM/YYYY\u00a0HH:mm.ss'),
            style: styles[lineStyle],
            user: `<span class="label label-${userStyle}">${item.user}</span>`,
            survStatus: null,
            cvtStatus: null,
            users: []
          }
        }

        if (item.surv != null) {
          line.year = item.surv.year
          line.survStatus = convention.display.surveillanceStatus(
            item.surv.year,
            item.surv.stat
          )
        } else if (item.cvt) {
          const mainStatus = convention.display.conventionStatus(
            item.cvt.stat
          )

          const rolesStatus = []
          const roles = ['reg', 'dir', 'bio']

          let hasMemberChanges = false
          for (let j = 0; j !== roles.length; ++j) {
            const role = roles[j]
            const changeDetail = item.cvt.rols[role]

            if (changeDetail == null) {
              continue
            }
            const roleStatusDisplay = convention.display.roleStatus(changeDetail.status)
            rolesStatus.push(roleStatusDisplay)

            const roleDisplay = convention.display.role(role)
            line.users.push({
              key: role,
              text: `${roleDisplay}&nbsp;${changeDetail.changeString}`
            })

            hasMemberChanges = hasMemberChanges || changeDetail.status > 0
          }

          if (item.cvt.stat === 3 && hasMemberChanges) {
            line.cvtStatus = rolesStatus
          } else {
            line.cvtStatus = [mainStatus]
          }
        }

        previousLine = line
      }

      if (previousLine != null) {
        result.push(previousLine)
      }
      return result
    },

    conventionHistoryDisplay: function () {
      const lines = this.conventionHistoryList
      if (lines == null) {
        return null
      }

      const result = this.dateSort ? lines.slice().reverse() : lines
      return result
    },

    showConventionHistory: function () {
      return this.conventionHistoryDisplay != null
    },

    currentYear: function () {
      return this.surveillance != null &&
             go.date.currentYear === this.surveillance.year
    },

    actions: function () {
      const result = {
        dl: this.conventionReceived,
        up: this.currentYear && this.showUploadConvention,
        acc: this.currentYear && this.conventionWaiting,
        ref: this.currentYear && (
          this.conventionWaiting ||
          (
            this.conventionAccepted &&
            this.surveillance.cvt.bio.stat === 0 &&
            this.surveillance.cvt.dir.stat === 0 &&
            this.surveillance.cvt.reg.stat === 0
          )
        )
      }

      for (let e in result) {
        if (result[e]) {
          result.empty = false
          return result
        }
      }

      result.empty = true
      return result
    },

    roles: function () {
      const { reg, dir, bio } = this.surveillance.cvt
      const nr = {
        name: '(Non renseigné)',
        fn: '(Non renseigné)',
        eml: '(Non renseignée)',
        stat: 0
      }

      const statuses = {
        0: {
          show: false
        },
        1: {
          show: true,
          class: 'label-info',
          text: this.surveillance.cvt.main === 3
            ? `En attente de l'avenant` : `En attente de la charte`
        },
        2: {
          show: true,
          class: 'label-warning',
          text: 'Avenant en attente de validation'
        },
        3: {
          show: true,
          class: 'label-success',
          text: 'Avenant validé'
        }
      }

      const amend = this.reason.type === 1 && this.reason.amend
      const one = reg.stat === 2 || dir.stat === 2 || bio.stat === 2
      const result = [
        {
          key: 'reg',
          title: `${convention.icons.reg}&nbsp;Responsable du programme`,
          src: reg,
          stat: statuses[reg.stat],
          dl: reg.stat > 1,
          send: this.currentYear && reg.stat >= 1,
          wait: one || amend,
          file: {
            title: 'RESPONSABLE',
            role: 3
          }
        },
        {
          key: 'dir',
          title: `${convention.icons.dir}&nbsp;Directeur de l'établissement`,
          subtitle: '(ou son représentant)',
          src: dir.name === '' ? nr : dir,
          stat: statuses[dir.stat],
          dl: dir.stat > 1,
          send: this.currentYear && dir.stat >= 1,
          wait: one || amend,
          file: {
            title: 'DIRECTEUR',
            role: 2
          }
        },
        {
          key: 'bio',
          title: `${convention.icons.bio}&nbsp;Biologiste`,
          src: bio.name === '' ? nr : bio,
          stat: statuses[bio.stat],
          dl: bio.stat > 1,
          send: this.currentYear && bio.stat >= 1,
          wait: one || amend,
          file: {
            title: 'BIOLOGISTE',
            role: 1
          }
        }
      ]
      return result
    },

    registrator: function () {
      return this.surveillance.cvt.reg
    },

    conventionBusy: function () {
      return this.convention.busy || this.convention.uploading
    },

    conventionReceived: function () {
      return this.surveillance != null && this.surveillance.cvt.main >= 2
    },

    conventionRefused: function () {
      return this.surveillance != null &&
        this.surveillance.cvt.stat === 3
    },

    conventionAccepted: function () {
      return this.surveillance != null &&
        this.surveillance.cvt.stat === 2
    },

    conventionWaiting: function () {
      return this.surveillance != null &&
        this.surveillance.cvt.stat === 1
    },

    conventionReceptionDate: function () {
      if (this.surveillance == null) {
        return ''
      }
      return date.tostr(this.surveillance.cvt.date, true)
    },

    showUploadConvention: function () {
      return this.currentYear &&
             this.surveillance.cvt.main > 0 &&
             this.surveillance.cvt.main !== 3 &&
             (!this.conventionReceived || this.conventionRefused)
    },

    status: function () {
      const s = this.surveillance
      if (s == null) {
        return { class: '', title: '' }
      }

      const texts = {
        0: this.surveillance.cvt.main === 0
          ? 'Charte absente' : 'Charte non confirmée',
        1: 'Charte en attente de validation',
        2: 'Charte validée',
        3: 'Charte refusée',
        4: this.surveillance.cvt.main === 3
          ? `En attente d'avenant.s`
          : 'En attente de la charte'
      }
      const classes = {
        0: 'label-info',
        1: 'label-warning',
        2: 'label-success',
        3: 'label-danger',
        4: 'label-info'
      }

      return {
        class: classes[s.cvt.stat],
        title: texts[s.cvt.stat]
      }
    }
  },

  watch: {
    surveillance: {
      handler () {
        if (this.surveillance != null) {
          this.convention.uploading = false
          this.convention.busy = false
        }
      },
      deep: true
    },

    conventionModal: {
      handler () {
        this.$emit('input', this.conventionModal)
      },
      deep: true
    },

    value: function (value) {
      this.conventionModal = value
    }
  },

  methods: {
    toggleDateSort: function () {
      this.$set(this, 'dateSort', !this.dateSort)
    },

    refreshHistoryIFN: function (forceUpdate) {
      if (this.conventionHistoryData == null && !forceUpdate) {
        return
      }

      this.conventionHistoryData = null

      const vm = this
      const request = {
        id: this.surveillance.establishment.id
      }
      this.$store.dispatch('surveillances/getConventionHistory', request).then(
        function (response) {
          if (response.data.err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant la recuperation de l'historique de la charte : ${response.data.err}.`
            })
            return
          }
          vm.conventionHistoryData = response.data.v
        }
      )
    },

    conventionModalEnded: function () {
      this.convention.uploading = false
      this.convention.busy = false
      this.convention.uploadPercentage = 0
      this.conventionHistoryData = null
    },

    prepareUpload: function (role) {
      this.targetRole = role
      this.$refs.conventionModalFileInput.click()
    },

    uploadConvention: function (event) {
      const role = this.targetRole
      const file = event.target.files[0]
      event.target.value = ''

      if (!file) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          content: `Aucun fichier choisi.`
        })

        event.preventDefault()
        return
      }

      const maxMb = 6
      const limit = maxMb << 20
      if (file.size > limit) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          content: `La charte ne peut pas faire plus de ${maxMb}Mo.`,
          duration: 0
        })

        event.preventDefault()
        return
      }

      let formData = new FormData()
      formData.append('id', this.surveillance.establishment.id)
      formData.append('file', file)
      if (role != null) {
        formData.append('role', role)
      }

      let instance = this
      this.convention.uploading = true
      this.convention.uploadPercentage = 0
      let request = {
        year: this.surveillance.year,
        data: formData,
        progress: function (progressEvent) {
          instance.convention.uploadPercentage = parseInt(
            Math.round(progressEvent.loaded * 100 / progressEvent.total)
          )
        }
      }
      this.$store.dispatch('surveillances/uploadConvention', request).then(
        function (response) {
          if (response.data.err != null) {
            instance.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant l'envoi de la charte : ${response.data.err}.`
            })
            instance.convention.uploading = false
          } else {
            instance.refreshHistoryIFN()
          }
        }
      ).catch(
        function (e) {
          instance.$notify({
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant l'envoi de la charte : ${e}.`
          })
          instance.convention.uploading = false
        }
      )
    },

    acceptConvention: function () {
      let request = {
        year: this.surveillance.year,
        id: this.surveillance.id
      }

      this.convention.busy = true
      let instance = this
      this.$store.dispatch('surveillances/acceptConvention', request).then(
        function (response) {
          if (response.data.err != null) {
            instance.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant l'acceptation de la charte : ${response.data.err}.`
            })
            instance.convention.busy = false
          } else {
            instance.refreshHistoryIFN()
          }
        }
      ).catch(
        function (e) {
          instance.$notify({
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant l'acceptation de la charte : ${e}.`
          })
          instance.convention.busy = false
        }
      )
    },

    refuseConvention: function () {
      this.reasonModal = true
      this.reason.text = ''
      this.reason.error = ''
      this.reason.reg = 0
      this.reason.bio = 0
      this.reason.dir = 0
      const { cvt } = this.surveillance
      this.reason.type = cvt.main >= 2 && cvt.bio.stat === 0 &&
                         cvt.dir.stat === 0 && cvt.reg.stat === 0 ? 1 : 0
      this.reason.amend = false
      this.reason.whole = true
    },

    checkReason: function (msg) {
      if (msg !== 'ok') {
        return true
      }

      if (this.reason.text === '') {
        this.reason.error = `Merci d'indiquer la raison du refus.`
        return false
      }

      if (this.reason.type === 1 && this.reason.whole) {
        return true
      }

      let wait = 0
      let refuse = false
      for (let r in this.roles) {
        const role = this.roles[r]
        if (!role.wait) {
          wait += 1
          continue
        }

        const rea = this.reason[role.key]

        if (this.reason.type === 0 && rea === 0 && role.src.stat === 2) {
          this.reason.error = `Merci de traiter tous les avenants.`
          return false
        }

        if (rea === 1) {
          refuse = true
          break
        }
      }

      if (wait !== this.roles.length && !refuse) {
        this.reason.error = `Au moins un avenant doit être refusé.`
        return false
      }

      return true
    },

    reasonModalEnded: function (msg) {
      if (msg !== 'ok') {
        return
      }
      let request = {
        id: this.surveillance.id,
        reason: this.reason.text,
        year: this.surveillance.year,
        bio: this.reason.bio,
        dir: this.reason.dir,
        reg: this.reason.reg
      }

      this.convention.busy = true
      let instance = this
      this.$store.dispatch('surveillances/refuseConvention', request).then(
        function (response) {
          if (response.data.err != null) {
            instance.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant le refus de la charte : ${response.data.err}.`
            })
            instance.convention.busy = false
          } else {
            instance.refreshHistoryIFN()
          }
        }
      ).catch(
        function (e) {
          instance.$notify({
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant le refus de la charte : ${e}.`
          })
          instance.convention.busy = false
        }
      )
    },

    downloadConvention: function () {
      const request = {
        id: this.surveillance.establishment.id,
        year: this.surveillance.year
      }

      this.getFile(`CHARTE D'ENGAGEMENT`, request)
    },

    downloadAmendment: function (r) {
      const request = {
        id: this.surveillance.establishment.id,
        year: this.surveillance.year,
        role: r.role
      }
      this.getFile(`AVENANT ${r.title}`, request)
    },

    getFile: function (title, request) {
      const s = this.surveillance
      const target = {
        filename: `SPIADI${s.year} - ${title} - ${s.establishment.name}.pdf`,
        blob: null
      }
      this.$store.dispatch('surveillances/downloadConvention', request).then(
        response => {
          target.blob = new Blob([response.data], { type: 'application/pdf' })
          this.convention.download = target
        }
      )
    }
  },

  mounted: function () {
    this.mounted = true
  },

  components: {
    'save-blob': saveBlob,
    'c-checkbox': checkbox
  }
}
</script>

<style lang="less" scoped>
@import '~variables';

.convention-modal {
  h3 {
    margin-top: 0rem;
  }

  h4:first-child {
    margin-top: 0rem;
  }

  ul {
    list-style-type: none;
    padding-left: 0rem;
  }

  .action-bar {
    display: flex;
    flex-flow: row wrap;
    align-content: space-around;
    align-items: center;
  }

  .action-item {
    margin: auto;
    flex-basis: 30%;
  }
}

.table td {
  font-size: 110%;
}

@media (min-width: @screen-lg-min){
  .convention-modal-container {
    .modal-lg {
      width: 1200px;
    }
  }

  .roles-container {
    max-width: 600px;
    margin: auto;
  }
}
</style>
